import React from 'react';
import { getTodayLocalDate } from '../../utils/date';
import './DateSelector.css';

const DateSelector = ({ date, onDateChange, className = '' }) => {
    const handleDateChange = (e) => {
        onDateChange(e.target.value);
    };

    const todayLocal = getTodayLocalDate();

    return (
        <div className={`date-selector ${className}`}>
            <label htmlFor="review-date" className="date-selector-label">
                Review Date:
            </label>
            <input
                id="review-date"
                type="date"
                value={date}
                onChange={handleDateChange}
                className="date-selector-input"
                max={todayLocal} // Don't allow future dates (using local timezone)
            />
        </div>
    );
};

export default DateSelector;

